/* GENERADO por scripts/shopify-theme/make-src.js desde assets/js/consent.js: no editar a mano. Lo carga layout/theme.liquid en el <head>. */
/* ExtraCM — Cookie consent (geo-estricto: solo UE/UK) + cargador de trackers.
   · Fuera de UE/UK  → tracking normal, SIN banner (consentimiento concedido por defecto).
   · En UE/UK        → Consent Mode v2 = denegado; GA4/Meta/TikTok/Clarity NO rastrean hasta "Accept".
                       El banner sale una vez; la elección se guarda en localStorage.
   Trackers: GA4 (G-0RBRE7XLXX, vía Consent Mode), Meta Pixel (1755101235675798),
             TikTok Pixel (DAF8CORC77UDHLL3L15G, el de la agencia desde el 2026-09-07),
             Microsoft Clarity (x3y27yx4ta, solo en las páginas /buy),
             Triple Whale (Triple Pixel "headless", tienda wz2vue-na.myshopify.com, desde el 2026-09-27).

   TEST: añade #cc-test a la URL para forzar el banner aunque no estés en UE.
   Reset: localStorage.removeItem('extracm_consent') y recarga.
*/
(function () {
  'use strict';

  var GA_ID      = 'G-0RBRE7XLXX';
  var FB_ID      = '1755101235675798';
  var CLARITY_ID = 'x3y27yx4ta';
  var KL_ID      = 'RqxvBG';            // Klaviyo public API key (company_id), el mismo que usa leadpopup.js
  var TT_ID      = 'DAF8CORC77UDHLL3L15G';   // TikTok Pixel de la agencia (2026-09-07); el anterior era D9Q7A5JC77U75PNH330G
  var STORE_KEY  = 'extracm_consent';   // 'granted' | 'denied'
  var POLICY_URL = '/legal.html';

  // ---------- región (heurística por zona horaria) ----------
  function inEurope() {
    try {
      var tz = (Intl.DateTimeFormat().resolvedOptions().timeZone || '');
      if (tz.indexOf('Europe/') === 0) return true;                 // toda la UE + UK
      // territorios UE/EEE fuera de "Europe/*"
      return ['Atlantic/Canary','Atlantic/Madeira','Atlantic/Azores','Atlantic/Reykjavik'].indexOf(tz) !== -1;
    } catch (e) { return true; }   // si no se puede detectar → tratamos como UE (lo estricto)
  }

  // ⚠️ MODO MEDICION — PUESTO EL 2026-09-02 A PETICION DEL USUARIO (agencia).
  // Con esto en true NO sale el banner y los pixeles arrancan para todos,
  // tambien en la UE. Es una excepcion deliberada al RGPD, no un descuido.
  // REVERTIR EN CUANTO LA AGENCIA TERMINE: poner false y desplegar (~30 s).
  // La vez anterior (2026-08-10) iba a ser rapido y estuvo 19 dias asi.
  var MEASURE_MODE = true;
  if (MEASURE_MODE) { try { var hb = document.createElement('style'); hb.id = 'ecm-hide-shopify-banner'; hb.textContent = '#shopify-pc__banner{display:none!important}'; document.head.appendChild(hb); } catch (e) {} }

  var stored = null;
  try { stored = localStorage.getItem(STORE_KEY); } catch (e) {}
  var isEU        = inEurope();
  var granted     = MEASURE_MODE || (stored === 'denied' ? false : ((!isEU) || stored === 'granted'));
  var needConsent = !MEASURE_MODE && isEU && stored !== 'granted' && stored !== 'denied';
  window.__ecmConsentGranted = granted;   // lo lee assets/js/stats.js (medición propia)
  if (location.hash.indexOf('cc-test') !== -1) { needConsent = true; granted = false; }  // test

  // ---------- qué página es ----------
  var path = location.pathname.replace(/\/index\.html$/, '').replace(/\/+$/, '') || '/';
  // Las 15 páginas de venta: /buy (GB, y también ie/ca/us por rewrite) y /xx/buy.
  // Hasta el 2026-08-06 esto era `path === '/buy'`, así que ViewContent y Clarity
  // solo saltaban en el /buy inglés: los otros 14 mercados no mandaban nada a Meta
  // ni a TikTok. /buy/pro ya no existe (301 a /buy), por eso no hay que excluirlo.
  // Al abrir un mercado hay que añadirlo AQUÍ además de en geo.js, vercel.json,
  // MARKETS, SHOPIFY_LOCALE y leadpopup.js.
  var isBuyPage = window.ECM_PAGE === 'buy';

  // ---------- Consent Mode v2 (GA4) ----------
  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function () { dataLayer.push(arguments); };
  var state = granted ? 'granted' : 'denied';
  gtag('consent', 'default', {
    ad_storage:        state,
    analytics_storage: state,
    ad_user_data:      state,
    ad_personalization:state,
    wait_for_update:   500
  });

  // ---------- Meta Pixel (se carga solo cuando hay permiso) ----------
  var metaLoaded = false;
  function loadMeta() {
    if (metaLoaded) return; metaLoaded = true;
    !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;
    n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,
    document,'script','https://connect.facebook.net/en_US/fbevents.js');
    fbq('init', FB_ID);
    fbq('track', 'PageView');
  }

  // ---------- Microsoft Clarity (solo /buy, solo con permiso) ----------
  var clarityLoaded = false;
  function loadClarity() {
    if (clarityLoaded || !isBuyPage) return; clarityLoaded = true;
    (function(c,l,a,r,i,t,y){
      c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
      t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
      y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
    })(window, document, "clarity", "script", CLARITY_ID);
  }

  // ---------- TikTok Pixel (se carga solo cuando hay permiso) ----------
  var ttLoaded = false;
  function loadTikTok() {
    if (ttLoaded) return; ttLoaded = true;
    !function (w, d, t) {
      w.TiktokAnalyticsObject=t;var ttq=w[t]=w[t]||[];ttq.methods=["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie","holdConsent","revokeConsent","grantConsent"],ttq.setAndDefer=function(t,e){t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}};for(var i=0;i<ttq.methods.length;i++)ttq.setAndDefer(ttq,ttq.methods[i]);ttq.instance=function(t){for(var e=ttq._i[t]||[],n=0;n<ttq.methods.length;n++)ttq.setAndDefer(e,ttq.methods[n]);return e},ttq.load=function(e,n){var r="https://analytics.tiktok.com/i18n/pixel/events.js",o=n&&n.partner;ttq._i=ttq._i||{},ttq._i[e]=[],ttq._i[e]._u=r,ttq._t=ttq._t||{},ttq._t[e]=+new Date,ttq._o=ttq._o||{},ttq._o[e]=n||{};n=document.createElement("script");n.type="text/javascript",n.async=!0,n.src=r+"?sdkid="+e+"&lib="+t;e=document.getElementsByTagName("script")[0];e.parentNode.insertBefore(n,e)};
      ttq.load(TT_ID);
      ttq.page();
    }(window, document, 'ttq');
  }

  // ---------- Triple Whale (Triple Pixel, instalación "headless") ----------
  // Nuestra web no es el tema de Shopify: es una web aparte que manda al checkout de
  // Shopify. Para Triple Whale eso es una tienda "headless", y su instalación
  // automática (el "Theme App Embed") no llega aquí: el píxel hay que ponerlo a mano.
  // El checkout ya lleva el suyo (lo instala la app de Triple Whale en Shopify).
  //
  // ⚠️ En Triple Whale → Pixel Settings seguirá saliendo "Online Store: Not installed".
  // Es normal: ese aviso solo mira el tema de Shopify. Lo dice su propia guía
  // ("Adding the Triple Pixel to a Headless Store"). Lo que manda es si llegan sesiones.
  //
  // El código de dentro es el snippet oficial tal cual (Settings → Pixel Settings →
  // Headless Installation), sin tocar. Va envuelto en try para que un fallo suyo no
  // se lleve por delante a Meta ni a TikTok, que se cargan en el mismo momento.
  //
  // Los eventos (AddToCart desde las páginas, Contact desde el pop-up) pasan por
  // ExtraCMConsent.tw(): se encolan aquí y salen cuando el píxel ha cargado, que
  // es tras la pintura. Sin la cola, un "Añadir al carrito" pulsado en el primer
  // segundo se perdería. Y si no hay consentimiento, no salen nunca.
  var twLoaded = false, twQueue = [];
  function twFlush() {
    if (!window.TriplePixel) return;
    while (twQueue.length) { try { window.TriplePixel.apply(window, twQueue.shift()); } catch (e) {} }
  }
  function loadTriple() {
    // El Triple Pixel lo pone la integración de la app de Triple Whale; aquí solo se vacía la cola cuando aparece.
    if (twLoaded) return; twLoaded = true;
    var n = 0, t = setInterval(function () { if (window.TriplePixel || ++n > 200) { clearInterval(t); twFlush(); } }, 250);
  }

  // ---------- Klaviyo onsite (se carga solo cuando hay permiso) ----------
  // Da "Active on Site" y permite los flujos de navegacion abandonada. Hasta el
  // 2026-09-16 Klaviyo solo veia lo que pasaba en el checkout de Shopify: la web
  // (extracm.com) no cargaba su script, asi que la navegacion era invisible.
  // El popup (leadpopup.js) llama a klaviyo.identify tras suscribirse, y ahi es
  // cuando la navegacion se asocia a un perfil. ~30 KB, async y tras la pintura,
  // igual que Meta y TikTok: no toca el LCP.
  var klLoaded = false;
  function loadKlaviyo() {
    // klaviyo.js lo carga la integración de la app de Klaviyo (App embeds); lo encolado en window.klaviyo sale cuando cargue.
    if (klLoaded) return; klLoaded = true;
    window.klaviyo = window.klaviyo || [];
  }

  // ---------- ViewContent (Meta + TikTok) ----------
  // El importe y la moneda dependen del mercado, que se calcula en MARKETS/CUR
  // DENTRO de la página — o sea, después de este fichero. Hasta el 2026-08-06 aquí
  // iba "29.99 GBP" fijo, así que a un australiano se le reportaba el evento en
  // libras. Ahora la página llama a ExtraCMConsent.viewContent({value, currency})
  // y aquí solo se encola hasta que haya permiso: cero precios duplicados.
  // Si la página no llama (HTML viejo en caché), a los 3 s se manda sin importe:
  // mejor un ViewContent sin valor que ningún ViewContent.
  // Con `defer`, /buy ya ha calculado su mercado antes que este fichero y nos
  // deja el importe aqui. Sin esto el ViewContent saldria sin valor.
  var vcData = (window.__ecmViewContent || null), vcSent = false, vcTimer = null;
  // force=true solo lo usa el temporizador de rescate. Sin él, fuera de la UE
  // enableAll() corre en el <head> y mandaría el evento SIN importe, porque la
  // página todavía no ha podido pasarlo — y luego ya lo daría por enviado.
  function sendViewContent(force) {
    if (vcSent || !isBuyPage || !granted) return;
    if (!vcData && !force) return;   // esperar el importe de la página
    // Los píxeles se cargan tras la pintura, así que cuando la página llama a
    // viewContent() todavía no existen fbq/ttq. Sin esta guarda se marcaba
    // vcSent=true sin haber mandado nada y el evento se perdía para siempre;
    // ya lo vuelve a llamar afterPaint() cuando los píxeles están puestos.
    if (!window.fbq && !window.ttq) return;
    vcSent = true;
    if (vcTimer) { clearTimeout(vcTimer); vcTimer = null; }
    var d = vcData || {};
    try {
      if (window.fbq) {
        var m = { content_name:'ExtraCM Soft Pro', content_type:'product', content_ids:['extracm-soft-pro'] };
        if (d.currency) { m.currency = d.currency; m.value = d.value; }
        fbq('track', 'ViewContent', m);
      }
    } catch (e) {}
    try {
      if (window.ttq) {
        var t = { contents:[{ content_id:'extracm-soft-pro', content_type:'product', content_name:'ExtraCM Soft Pro' }] };
        if (d.currency) { t.currency = d.currency; t.value = d.value; }
        window.ttq.track('ViewContent', t);
      }
    } catch (e) {}
  }
  // 6 s (antes 3): los pixeles ahora se cargan tras la pintura, y si el rescate
  // saltase antes marcaria vcSent y el evento se perderia.
  if (isBuyPage) vcTimer = setTimeout(function () { sendViewContent(true); sendViewedProduct(true); }, 6000);

  // ---------- Viewed Product (Klaviyo) ----------
  // Lo pide el flujo de navegacion abandonada que monta la agencia: dispara con
  // la metrica "Viewed Product", que del 18 al 24-sep estaba a 0 eventos, asi
  // que ese flujo no habria enviado nada nunca. Klaviyo solo guarda el evento si
  // el visitante ya esta identificado (el popup de leadpopup.js llama a identify,
  // o ya compro antes); del anonimo no queda nada, es asi por diseno de Klaviyo.
  // Se encola en window.klaviyo igual que hace leadpopup.js: si no hay permiso,
  // klaviyo.js no se carga, la cola se queda en memoria y NO sale nada a la red.
  // El importe sale de __ecmViewContent, el mismo dato que usa ViewContent, que
  // la pagina ya deja convertido a la moneda de su mercado: cero precios duplicados.
  var kvSent = false;
  function sendViewedProduct(force) {
    if (kvSent || !isBuyPage || !granted) return;
    if (!vcData && !force) return;   // esperar el importe de la pagina
    kvSent = true;
    var d = vcData || {};
    var canon = document.querySelector('link[rel="canonical"]');
    var item = {
      ProductName: 'ExtraCM Soft Pro',
      ProductID:   'extracm-soft-pro',
      Brand:       'ExtraCM',
      URL:         (canon && canon.href) || (location.origin + location.pathname),
      // Absoluta a proposito: esta imagen la pinta el correo, no la pagina, y los
      // /xx/buy no sirven /buy/img en relativo.
      ImageURL:    'https://extracm.com/buy/img/1-800.webp'
    };
    if (d.currency) { item.Price = d.value; item.Currency = d.currency; }
    try {
      window.klaviyo = window.klaviyo || [];
      window.klaviyo.push(['track', 'Viewed Product', item]);
      // Alimenta el bloque "visto recientemente" de las plantillas de Klaviyo.
      window.klaviyo.push(['trackViewedItem', {
        Title: item.ProductName, ItemId: item.ProductID, Url: item.URL,
        ImageUrl: item.ImageURL, Metadata: { Brand: item.Brand, Price: item.Price }
      }]);
    } catch (e) {}
  }

  // Clarity (grabación de sesiones, ~60 KB de JS) se aplaza hasta la primera
  // interacción o 5 s: es lo que más hilo principal comía en móvil (INP/TBT).
  // Meta y TikTok se cargan igual que antes: son atribución, no se tocan.
  function loadClarityLazy() {
    if (clarityLoaded || !isBuyPage) return;
    var done = false;
    function go() { if (done) return; done = true; loadClarity();
      ['scroll','touchstart','keydown','mousemove'].forEach(function (ev) { window.removeEventListener(ev, go); }); }
    ['scroll','touchstart','keydown','mousemove'].forEach(function (ev) { window.addEventListener(ev, go, { passive: true, once: true }); });
    setTimeout(go, 5000);
  }
  // Meta (235 KB) y TikTok (160 KB) sumaban ~550 ms de hilo principal y peleaban
  // con la imagen principal: PageSpeed daba LCP 6,5 s. Se cargan tras la pintura
  // o al primer gesto. No se pierde nada: los eventos van al mismo enableAll().
  function afterPaint(fn) {
    var EV = ['scroll','touchstart','keydown','mousemove','click'], done = false;
    function go(ev) {
      // Solo cuenta lo que hace la PERSONA. El desplegable de tallas pulsa por código
      // el botón de la talla preseleccionada al cargar (27-sep): ese clic falso
      // (isTrusted=false) despertaba a Meta, TikTok y Triple Whale antes de pintar
      // la página, justo lo que esta función existe para evitar.
      if (ev && ev.isTrusted === false) return;
      if (done) return; done = true;
      EV.forEach(function (e) { window.removeEventListener(e, go); });
      fn();
    }
    // Sin `once`: con él, el clic falso gastaba el listener y el primer clic real ya no llegaba.
    EV.forEach(function (e) { window.addEventListener(e, go, { passive: true }); });
    if (document.readyState === 'complete') setTimeout(go, 1500);
    else window.addEventListener('load', function () { setTimeout(go, 1500); });
  }
  function syncShopify(g) {
    try {
      var key = 'extracm_shopify_consent', v = g ? 'granted' : 'denied';
      try { if (localStorage.getItem(key) === v) return; } catch (e) {}
      var S = window.Shopify;
      if (!S || !S.loadFeatures) return;
      S.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
        if (err || !S.customerPrivacy) return;
        S.customerPrivacy.setTrackingConsent({ analytics: g, marketing: g, preferences: g, sale_of_data: g }, function () {
          try { localStorage.setItem(key, v); } catch (e) {}
        });
      });
    } catch (e) {}
  }
  function enableAll(now) {
    function go() { loadMeta(); loadTikTok(); loadTriple(); loadKlaviyo(); sendViewContent(); sendViewedProduct(); syncShopify(true); }
    // now=true al pulsar "Aceptar": la pagina ya esta pintada y el usuario acaba
    // de interactuar, no tiene sentido esperar mas.
    if (now) go(); else afterPaint(go);
    loadClarityLazy();
  }
  if (granted) enableAll();

  // ---------- banner ----------
  function grantConsent() {
    granted = true;   // imprescindible: sendViewContent() lo mira antes de disparar
    try { localStorage.setItem(STORE_KEY, 'granted'); } catch (e) {}
    window.__ecmConsentGranted = true;
    gtag('consent', 'update', {
      ad_storage:'granted', analytics_storage:'granted',
      ad_user_data:'granted', ad_personalization:'granted'
    });
    enableAll(true);
    hideBanner();
  }
  function denyConsent() {
    granted = false;
    try { localStorage.setItem(STORE_KEY, 'denied'); } catch (e) {}
    gtag('consent', 'update', {
      ad_storage:'denied', analytics_storage:'denied',
      ad_user_data:'denied', ad_personalization:'denied'
    });
    // Triple Whale pide que se le avise del rechazo una vez (su guía, "Managing Tracking Consent").
    try { if (twLoaded && window.TriplePixel) window.TriplePixel('trackingConsent', false); } catch (e) {}
    syncShopify(false);
    if (metaLoaded || clarityLoaded || twLoaded) { location.reload(); return; }  // ya cargados → recarga para detenerlos
    hideBanner();   // sigue denegado; GA4 manda pings sin cookies (modelado)
  }
  function hideBanner() {
    var el = document.getElementById('cc-banner');
    if (el && el.parentNode) el.parentNode.removeChild(el);
  }
  function renderBanner() {
    if (document.getElementById('cc-banner')) return;
    var css =
      '#cc-banner{position:fixed;left:50%;bottom:16px;transform:translateX(-50%);z-index:2147483600;'
      + 'width:calc(100% - 24px);max-width:680px;display:flex;align-items:center;gap:14px;flex-wrap:wrap;'
      + 'justify-content:space-between;background:rgba(10,10,10,.96);-webkit-backdrop-filter:blur(8px);'
      + 'backdrop-filter:blur(8px);border:1px solid rgba(0,200,240,.35);border-radius:14px;padding:14px 16px;'
      + 'box-shadow:0 10px 40px rgba(0,0,0,.5);color:#e8eef2;'
      + 'font-family:-apple-system,"Helvetica Neue",Arial,sans-serif;font-size:13px;line-height:1.45;'
      + 'animation:ccUp .35s ease-out}'
      + '@keyframes ccUp{from{opacity:0;transform:translate(-50%,12px)}to{opacity:1;transform:translate(-50%,0)}}'
      + '#cc-banner .cc-txt{flex:1 1 260px;min-width:200px}'
      + '#cc-banner a{color:#00C8F0;text-decoration:underline}'
      + '#cc-banner .cc-btns{display:flex;gap:8px;flex:0 0 auto}'
      + '#cc-banner .cc-btn{cursor:pointer;border-radius:9px;padding:9px 16px;font-size:13px;font-weight:700;'
      + 'border:1px solid transparent;font-family:inherit;-webkit-appearance:none}'
      + '#cc-banner .cc-reject{background:transparent;color:#cdd6dc;border-color:rgba(255,255,255,.25)}'
      + '#cc-banner .cc-reject:hover{background:rgba(255,255,255,.08)}'
      + '#cc-banner .cc-accept{background:#00C8F0;color:#05222b}'
      + '#cc-banner .cc-accept:hover{filter:brightness(1.08)}'
      + '@media(max-width:560px){#cc-banner{flex-direction:column;align-items:stretch;gap:9px;'
      + 'bottom:8px;width:calc(100% - 16px);padding:11px 13px;border-radius:12px;font-size:12px;line-height:1.4}'
      + '#cc-banner .cc-txt{flex:none;min-width:0}'
      + '#cc-banner .cc-btns{justify-content:stretch;gap:7px}'
      + '#cc-banner .cc-btn{flex:1;padding:8px 12px;font-size:12.5px}}';
    if (!document.getElementById('cc-banner-styles')) {
      var style = document.createElement('style');
      style.id = 'cc-banner-styles';
      style.textContent = css;
      document.head.appendChild(style);
    }

    // Textos del banner según el idioma de la página (<html lang="es|fr|it|pl|de|pt-PT|es-MX">).
    // El idioma del TEXTO y el prefijo de la RUTA son cosas distintas: /mx lleva
    // lang="es-MX" y su texto es español, pero su política vive en /mx/legal.html.
    // Cortar el lang a 2 letras daría "es" y enlazaría a la página de España.
    var ccFull = (document.documentElement.lang || 'en').toLowerCase();
    // TODOS los locales con legal.html propio. /ie y /ca quedan fuera a proposito:
    // son reescrituras del master ingles y su politica ES la de la raiz.
    var ccPath = (location.pathname.match(/^\/(pl|fr|it|es|de|pt|mx|cl|nl|cs|el|au|nz|co|pe|pa|uy|pr|ja|us)(?:\/|$)/) || [])[1] || '';
    var CC_T = {
      en: { txt:'We use cookies to analyse traffic and improve your experience. ', pol:'Privacy Policy',           rej:'Reject',   acc:'Accept',    aria:'Cookie consent' },
      es: { txt:'Usamos cookies para analizar el tráfico y mejorar tu experiencia. ', pol:'Política de privacidad', rej:'Rechazar', acc:'Aceptar',   aria:'Consentimiento de cookies' },
      fr: { txt:'Nous utilisons des cookies pour analyser le trafic et améliorer votre expérience. ', pol:'Politique de confidentialité', rej:'Refuser', acc:'Accepter', aria:'Consentement aux cookies' },
      it: { txt:'Usiamo i cookie per analizzare il traffico e migliorare la tua esperienza. ', pol:'Informativa sulla privacy', rej:'Rifiuta', acc:'Accetta', aria:'Consenso ai cookie' },
      pl: { txt:'Używamy plików cookie, aby analizować ruch i ulepszać Twoje wrażenia. ', pol:'Polityka prywatności', rej:'Odrzuć', acc:'Akceptuję', aria:'Zgoda na pliki cookie' },
      de: { txt:'Wir verwenden Cookies, um den Traffic zu analysieren und deine Erfahrung zu verbessern. ', pol:'Datenschutzerklärung', rej:'Ablehnen', acc:'Akzeptieren', aria:'Cookie-Einwilligung' },
      pt: { txt:'Usamos cookies para analisar o tráfego e melhorar a tua experiência. ', pol:'Política de privacidade', rej:'Rejeitar', acc:'Aceitar', aria:'Consentimento de cookies' },
      nl: { txt:'We gebruiken cookies om het verkeer te analyseren en je ervaring te verbeteren. ', pol:'Privacybeleid', rej:'Weigeren', acc:'Accepteren', aria:'Cookietoestemming' },
      cs: { txt:'Používáme cookies k analýze návštěvnosti a zlepšení tvého zážitku. ', pol:'Zásady ochrany soukromí', rej:'Odmítnout', acc:'Přijmout', aria:'Souhlas s cookies' },
      el: { txt:'Χρησιμοποιούμε cookies για να αναλύουμε την επισκεψιμότητα και να βελτιώνουμε την εμπειρία σου. ', pol:'Πολιτική απορρήτου', rej:'Απόρριψη', acc:'Αποδοχή', aria:'Συγκατάθεση cookies' },
      // En japonés la frase no termina en punto tras el enlace: 'end' cierra la frase.
      ja: { txt:'当サイトでは、アクセス解析と利便性向上のためにCookieを使用しています。詳しくは', pol:'プライバシーポリシー', end:'をご覧ください。', rej:'拒否する', acc:'同意する', aria:'Cookieの使用について' }
    };
    // "es-MX" no tiene entrada propia (el texto español vale igual en México):
    // se prueba el código completo y, si no está, la parte de idioma.
    var cct = CC_T[ccFull] || CC_T[ccFull.slice(0, 2)] || CC_T.en;
    // La política localizada sale de la RUTA, no del idioma: /mx → /mx/legal.html
    var polUrl = (window.ECM_LEGAL_URL || '/pages/legal') + '#privacy';
    var bar = document.createElement('div');
    bar.id = 'cc-banner';
    bar.setAttribute('role', 'dialog');
    bar.setAttribute('aria-label', cct.aria);
    bar.innerHTML =
      '<div class="cc-txt">' + cct.txt
      + '<a href="' + polUrl + '">' + cct.pol + '</a>' + (cct.end || '.') + '</div>'
      + '<div class="cc-btns">'
      +   '<button type="button" class="cc-btn cc-reject" id="cc-reject">' + cct.rej + '</button>'
      +   '<button type="button" class="cc-btn cc-accept" id="cc-accept">' + cct.acc + '</button>'
      + '</div>';
    document.body.appendChild(bar);
    document.getElementById('cc-accept').addEventListener('click', grantConsent);
    document.getElementById('cc-reject').addEventListener('click', denyConsent);
  }

  // punto de entrada para "gestionar cookies" (desde la política de cookies)
  window.ExtraCMConsent = {
    open: function () {
      hideBanner();
      if (document.body) renderBanner();
      else document.addEventListener('DOMContentLoaded', renderBanner);
    },
    // La llama /buy (los 15) con el precio ya convertido a su mercado. Si todavía
    // no hay consentimiento se guarda y lo manda enableAll() al pulsar "Aceptar".
    viewContent: function (data) {
      if (vcSent && kvSent) return;
      if (!vcSent) vcData = data || {};
      sendViewContent();
      sendViewedProduct();
    },
    // Eventos de Triple Whale: ExtraCMConsent.tw('AddToCart', {item, q, v}),
    // ExtraCMConsent.tw('Contact', {email}). Se encolan hasta que el píxel carga.
    tw: function () {
      twQueue.push(Array.prototype.slice.call(arguments));
      if (twLoaded) twFlush();
    }
  };

  if (needConsent) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', renderBanner);
    else renderBanner();
  }
})();
